export default __webpack_public_path__ + "static/media/Jett_artwork.074a43fb.png";